<template>
  <div class="module-root" v-if="checkModuleFalg">
    <div
      style="line-height: 50px; font-size: 22px; color: rgb(255, 255, 255); background: #f13a58; text-align: center;"
    >每日签到获得积分</div>
    <i
      class="el-icon-circle-close"
      style="font-size: 24px;position: absolute;top: 13px;right: 13px;color: #fff;"
      @click="closeModule"
    />
    <div class="check-root">
      <template v-for="(dItem,zindex) in 7">
        <div :key="'d' + zindex">
          <div
            :class="[ 'check-dots', 'check-dot-position-' + dItem, Number(dItem) <= Number(continueSign) ? 'checked-dots':'unchecked-dots']"
          >{{ dItem }}</div>
        </div>
      </template>
      <template v-for="(eItem,yindex) in 7">
        <div
          :key="'y' + yindex"
          :class="['check-show-root', Number(eItem) <= Number(continueSign) ? 'checked-show-bg' : 'unchecked-show-bg', 'check-show-position-' + eItem]"
        >
          <div
            :class="['check-mark', Number(eItem) <= Number(continueSign) ? 'checked-mark' : 'unchecked-mark']"
          ></div>
          <div class="check-mark-text">{{ Number(eItem) <= Number(continueSign) ? '已签' : '待签' }}</div>
          <div
            :class="['check-coin', Number(eItem) <= Number(continueSign) ? 'checked-coin' : 'unchecked-coin']"
          >分</div>
          <div class="jf-add-text">{{ Number(eItem) === 7 ? '+15积分' : '+5积分' }}</div>
          <span
            :class="['check-arrow', Number(eItem) <= Number(continueSign) ? 'checked-arrow' : 'unchecked-arrow']"
          >123</span>
        </div>
      </template>
    </div>
    <div
      style="bottom: 50px; position: absolute; right: 0; left: 0;text-align:center;"
      v-if="!hasSigned"
    >
      <el-button @click="toCheck">马上签到</el-button>
    </div>
    <div
      style="font-size: 14px;line-height: 24px;border-top: 1px solid #e0e0e0;color: #666; bottom: 0; position: absolute; right: 0; left: 0;"
    >
      <div style=" float: left; width: 120px;  padding: 0 20px;">
        本月已领:
        <span
          style="color:#444"
        >{{ signInfo && signInfo.monthcredits ? signInfo.monthcredits : 0 }}</span>
      </div>
      <div style=" float: left; width: 120px;  padding: 0 20px;">
        积分余额:
        <span
          style="color:#444"
        >{{ signInfo && signInfo.usercredits ? signInfo.usercredits : 0 }}</span>
      </div>
      <div style=" float: right; padding: 0 20px;color: #f13a58" v-show="false">积分活动兑换记录</div>
    </div>
  </div>
</template>
<script>
import xyAPI from '@/api/xyAPI'
import loadData from '@/https/loadData'
export default {
  name: 'CheckModule',
  computed: {
    signInfo () {
      return this.$store.getters.signInfo
    },
    continueSign () {
      return this.$store.getters.continueSign
    },
    hasSigned () {
      return this.$store.getters.hasSigned
    }
  },
  props: {
    checkModuleFalg: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  methods: {
    closeModule() {
      this.$emit('closeModule')
    },
    async toCheck () {
      const _that = this
      try {
        const res = await loadData(xyAPI.userSignin, {})
        if (res && String(res.code) === '0') {
          _that.$store.dispatch('getSignInfo')
          _that.$message('操作成功')
          _that.closeModule()
        } else {
          _that.$message(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.module-root {
  width: 600px;
  height: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -250px;
  margin-left: -300px;
  background: #fff;
  z-index: 99999;
  .check-root {
    width: 400px;
    height: 100px;
    border: 2px solid #32cd32;
    border-left: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -200px;
  }
  .check-dots {
    width: 12px;
    height: 12px;
    position: absolute;
    color: #fff;
    border-radius: 12px;
    font-size: 12px;
    text-align: center;
    line-height: 12px;
  }
  .checked-dots {
    border: 2px solid rgb(50, 205, 50);
    background: #f4a460;
  }
  .unchecked-dots {
    border: 2px solid #888;
    background: #aaa;
  }
  .check-dot-position-1 {
    top: -8px;
    left: 67px;
  }
  .check-dot-position-2 {
    top: -8px;
    left: 150px;
  }
  .check-dot-position-3 {
    top: -8px;
    left: 233px;
  }
  .check-dot-position-4 {
    top: -8px;
    left: 316px;
  }
  .check-dot-position-5 {
    bottom: -8px;
    left: 296px;
  }
  .check-dot-position-6 {
    bottom: -8px;
    left: 192px;
  }
  .check-dot-position-7 {
    bottom: -8px;
    left: 88px;
  }
  .check-show-root {
    overflow: hidden;
    width: 76px;
    height: 50px;
    margin-left: -38px;
    position: absolute;
    border-radius: 3px;
    -webkit-box-shadow: 2px 2px 3px #bbb;
    box-shadow: 2px 2px 3px #bbb;
  }
  .checked-show-bg {
    background: #98fb98;
  }
  .unchecked-show-bg {
    background: #e0e0e0;
  }
  .check-show-position-1 {
    left: 75px;
    top: -70px;
  }
  .check-show-position-2 {
    left: 158px;
    top: -70px;
  }
  .check-show-position-3 {
    left: 241px;
    top: -70px;
  }
  .check-show-position-4 {
    left: 324px;
    top: -70px;
  }
  .check-show-position-5 {
    left: 304px;
    bottom: 20px;
  }
  .check-show-position-6 {
    left: 200px;
    bottom: 20px;
  }
  .check-show-position-7 {
    left: 96px;
    bottom: 20px;
  }
  /* 使用矩形旋转, 和父节点的 overflow:hidden 配合 */
  .check-mark {
    position: absolute;
    width: 50px;
    height: 50px;
    top: 0;
    right: 0;
    margin: -25px -25px 0 0;

    transform: rotateZ(45deg);
  }
  .check-mark-text {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    font-size: 12px;
    line-height: 25px;
    color: #fff;
    transform: rotateZ(45deg);
  }
  .checked-mark {
    background: #66cdaa;
  }
  .unchecked-mark {
    background: #aaa;
  }
  .check-coin {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -20px;
    left: 50%;
    margin-left: -13px;
    border-radius: 30px;
    color: rgb(240, 241, 242);
    text-align: center;
    line-height: 22px;
  }
  .checked-coin {
    background: rgb(205, 133, 63);
    border: 2px solid rgb(210, 105, 30);
  }
  .unchecked-coin {
    background: #999;
    border: #aaa;
  }
  .jf-add-text {
    text-align: center;
    font-size: 12px;
    color: #666;
    margin-top: 32px;
  }
  .check-arrow {
    display: block;
    border-width: 5px;
    position: absolute;
    bottom: -10px;
    left: 33px;
    border-style: solid dashed dashed;
    font-size: 0;
    line-height: 0;
  }
  .checked-arrow {
    border-color: #98fb98 transparent transparent;
  }
  .unchecked-arrow {
    border-color: #e0e0e0 transparent transparent;
  }
}
</style>